// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as SurgeRepoConfig from "./SurgeRepoConfig.bs.js";
import * as Network$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as SurgeRequestEncoder from "./SurgeRequestEncoder.bs.js";

function fetchCampaigns(geoRegionId, country) {
  var urlParams = {};
  urlParams["geo_region_id"] = String(geoRegionId);
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/manual_surge/fetch_live_campaigns", urlParams);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SurgeRepoConfig.SurgeCampaignResponseConverter.execute, result);
                        });
            });
}

function fetchGeoRegions(country) {
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/geo_regions/active_geo_regions", {});
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SurgeRepoConfig.SurgeGeoRegionResponseConverter.execute, result);
                        });
            });
}

function fetchVehicleTypes(geoRegionId, country) {
  var urlParams = {};
  urlParams["geo_region_id"] = String(geoRegionId);
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/geo_regions/active_vehicles", urlParams);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SurgeRepoConfig.SurgeVehicleTypesResponseConverter.execute, result);
                        });
            });
}

function fetchZones(geoRegionId, country) {
  var urlParams = {};
  urlParams["geo_region_id"] = String(geoRegionId);
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/geo_regions/current_zones", urlParams);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SurgeRepoConfig.SurgeZonesResponseConverter.execute, result);
                        });
            });
}

function createCampaign(newCampign, country) {
  var payload = JSON.stringify(SurgeRequestEncoder.CreateCampaign.encodeCreateCampaignPayload(newCampign));
  var requestUrl = $$String.concat("", {
        hd: Config.Env.getHostName(undefined),
        tl: {
          hd: "/manual_surge/create_campaign",
          tl: /* [] */0
        }
      });
  return Network$Catalyst.postRequestV2(requestUrl, payload, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SurgeRepoConfig.SurgeCreateCampaignResponseConverter.execute, result);
                        });
            });
}

function deleteCampiagn(geoRegionId, country) {
  var requestUrl = $$String.concat("", {
        hd: Config.Env.getHostName(undefined),
        tl: {
          hd: "/manual_surge/deactivate_campaign?campaign_id=" + String(geoRegionId),
          tl: /* [] */0
        }
      });
  return NetworkV2$Catalyst.$$delete(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SurgeRepoConfig.SurgeDeleteCampaignResponseConverter.execute, result);
                        });
            });
}

var SurgeRepo = {
  fetchCampaigns: fetchCampaigns,
  fetchGeoRegions: fetchGeoRegions,
  fetchVehicleTypes: fetchVehicleTypes,
  fetchZones: fetchZones,
  createCampaign: createCampaign,
  deleteCampiagn: deleteCampiagn
};

export {
  SurgeRepo ,
  
}
/* Config Not a pure module */
